// extracted by mini-css-extract-plugin
export default {"container":"container--jSI4M","job-post":"job-post--5RVKG","jobPost":"job-post--5RVKG"};